import { useCallback, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

export const VOLUME_TYPE = {
    UNKNOWN: 0,
    MESSAGE_RECEIVED: 1,
    PLAYER_TURN: 2,
};

export default function useSound(sound, volumeType) {
    const volume = useSelector((state) => {
        let v;
        switch (volumeType) {
            case VOLUME_TYPE.MESSAGE_RECEIVED: v = state.settings.messageReceivedVolume; break;
            case VOLUME_TYPE.PLAYER_TURN:      v = state.settings.playerTurnVolume; break;
            default:
                return state.settings.allAudioVolume / 100;
        }
        return (v/100) * (state.settings.allAudioVolume/100);
    });
    const soundVolumeRef = useRef(volume);

    useEffect(() => {
        soundVolumeRef.current = volume;
    }, [volume, soundVolumeRef]);

    return useCallback(() => {
        sound.play(soundVolumeRef.current);
    }, [soundVolumeRef, sound]);
}